class Events {
    constructor(events) {
        this.column = events.column;    // person column
        this.events = events.events;
    }
}

export default Events;
